<template>
    <div class="col-sm-12">
        <h4 class="heading">Fees &amp; Charges</h4><hr>
        <div class="row">
            <div class="col-sm-4 form-group" v-if="refresh" v-for="(fee, i) in formInput" v-bind:key="i">
                <label>{{fee.name}}<span> : &nbsp;&nbsp;</span></label>
                <span>{{fee.value}}&nbsp;({{fee.rate+' '+(fee.basic=='P'?'%':(fee.basic=='BP'?'Basis Point':(formData.stock.currency)))}})</span>
                <div v-if="formData.action!='view'" class="input-group"> 
                    <select class="form-control w-40" v-model="fee.basic" @change="calc_value">
                        <option value="P">Percentage</option>
                        <option value="F">Fixed Value</option>
                        <option value="BP">Basis Point</option>
                    </select>
                    <input type="number" v-model="fee.rate" min="0" @change="calc_value" class="form-control w-60"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SimpleVueValidator from 'simple-vue-validator';
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import 'vue-material/dist/vue-material.css';
import common from '@/assets/js/common.js';

const Validator = SimpleVueValidator.Validator;
export default {
    name: "AddBulkCustomer",
    props: ['row', 'formData', 'index'],
    mixins: [common, SimpleVueValidator.mixin],
    components: {VueBootstrapTypeahead},
    data(){
        return {
          formInput:[],
          refresh:1,
          total_other_charges : 0,
          total_consideration: 0
        };
    },
    validators: {
    },
    created(){
        if(typeof this.row != 'undefined'){
            Object.assign(this.formInput, this.row);
        }
        //this.calc_value();
        //console.log('a',this.formInput);
    },
    mounted(){
        if(this.action == 'view'){
            var el = this.$el.getElementsByTagName("label");
            for (var i = 0; i<el.length; i++) {
                el[i].style.fontWeight = 600;
            }
        }
    },
    watch: {
      formInput : {
        handler:function(value) {
            Promise.all( this.calc_value() ).then(
                function(){
                    this.$emit('feesAndCharges',this.formInput);
                    console.log(this.formInput)
                }
            )
        },
        deep : true,
      },
      'formData.total_quantity': function(value) {
          this.calc_value()
      },
      'formData.broker_trade_price': function(value) {
          this.calc_value()
      },
      'formData.trade_price': function(value) {
          this.calc_value()
      },
    },
    methods: {
        calc_value: function(){   
            this.refresh=0;  
            let quantity = (Object.keys(this.formData.account_detail).length>1?this.formData.account_detail[this.index].quantity:this.formData.total_quantity);
            let trade_value = (quantity*(this.formData.trade_price?this.formData.trade_price:this.formData.broker_trade_price));

            this.total_other_charges = 0;
            this.formInput.forEach((fee, i) => {
                if(fee.basic == 'P') this.formInput[i].value = this.formatNumber(parseFloat(fee.rate * (trade_value/100)));

                else if(fee.basic == 'F') this.formInput[i].value = parseFloat(fee.rate);

                else if(fee.basic == 'BP') this.formInput[i].value = parseFloat((fee.rate/100/100) * trade_value);

                this.total_other_charges += fee.value;
                
            });

            this.total_other_charges += parseFloat(this.formInput.exchange_fee);
            if(this.formData.type.search(/buy|fop in|transfer in|give in|dvp in|withdrawal|charges|fees/i) >= 0) this.total_consideration = trade_value + this.total_other_charges;
            else this.total_consideration = parseFloat(trade_value) - parseFloat(this.total_other_charges);

            this.$emit('feesAndCharges',this.formInput)
            this.refresh=1;
        }
    }
}
</script>
<style scoped>
.form-check-label{
  padding-left: 5px !important;
  vertical-align: middle;
  /* vertical-align: -moz-middle-with-baseline; */
}
.form-check{
  padding-left: 30px !important;
}
</style>